module.exports = __webpack_public_path__ + "img/dark2_close_icon.95fb97e3.svg";